export default {"src":"/_next/static/media/ra-tailor-benefits.336c759b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};